export default __webpack_public_path__ + "340eb23bf38f26f312e176afb40afedc.svg";